import { AbilityBuilder } from "@casl/ability";
import { AppAbility } from "modules/auth";

export const defineRulesForPrivateAdviser = (abilityBuilder: AbilityBuilder<AppAbility>) => {
    const { can, rules, cannot } = abilityBuilder;

    cannot("view", "UserActivityModule");
    cannot("view", "UserAdministrationModule");
    cannot("view", "ModulesAdministrationModule");
    cannot("view", "CommunicationModule");
    can("view", "UserNotificationsModule");

    can("view", "InternalSystemsModule");
    can("view", "ExternalModules");
    can("view", "AdditionalModules");
    can("view", "EducationAnalysis");
    cannot("view", "SemisAdministrationModule");
    cannot("view", "SEMIS");
    cannot("view", "InternalDocumentation");
    cannot("view", "PIO");
    cannot("view", "Webtop");
    cannot("view", "ReportProblem");

    can("view", "Records");
    cannot("update", "Records");

    cannot("view", "EducationModule");
    cannot("view", "EducationLinks");
    cannot("view", "EducationDocuments");
    cannot("update", "EducationDocuments");

    cannot("update", "UserRole");

    can("view", "PresentationsModule");
    can("view", "CourseList");
    can("view", "CourseRegistration");
    can("view", "FarmList");
    can("view", "AgroclimateStations");
    can("view", "DownloadPresentation");
    can("view", "WeatherAlarmToggle");

    cannot("view", "Beekeeping");
    cannot("update", "Beekeeping");

    return rules;
};
